import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Debugger} from "debug";
import IResourceArray = ng.resource.IResourceArray;

const debug: Debugger = require('debug')('SakstypeRessurs');

export class SakstypeRessurs extends BasisRessurs<l.SakstypeModell> {

    static regNavn = "sakstype";

    static forInjisering() {
        return [
            "$resource",
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            SakstypeRessurs]
    }

    constructor($resource: ng.resource.IResourceService, ressursFeilhåndtering: RessursFeilhåndtering, gettextCatalog: gettextCatalog) {
        super("sakstype", $resource, ressursFeilhåndtering, gettextCatalog,
            {
                'oppdatersakstype': {method: 'POST', url: "/api/sakstype/oppdater", isArray: true},
                'finnAlle': {method: 'GET', url: "/api/sakstype/:gruppeId", isArray: true}
            });
    }


    //offentlige metoder

    tilgjengeligeSakstyper(gruppeId: string): IResourceArray<l.SakstypeModell> {
        debug("tilgjengeligeSakstyper", gruppeId);
        return this.ressurs['finnAlle'](
            {gruppeId: gruppeId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente frem sakstype"))
        )
    }

    oppdaterSakstype(gruppeId: string, sakstypeListe: l.SakstypeSpesifikasjon[], vedOk: Function = _.noop): IResourceArray<l.SakstypeModell> {
        debug("Oppdaterer sakstype ", sakstypeListe);
        return this.ressurs['oppdatersakstype']({
                gruppeId: gruppeId,
                sakstyper: sakstypeListe
            },
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere sakstype. Prøv på nytt om litt.")));
    }
}
